import React, { useEffect, useState } from "react"
import { Grid } from "@mui/material"
import { getCustomerList } from "services/customerService"

function CustomerDropDown ({
    phoneNumber, 
    closeDropDown,
    setCloseDropDown,
    onChange,
    setAllowFilter,
    excludeName = false
}) {

    const [ customerList, setCustomerList ] = useState([])

    useEffect(() => {
        loadCustomer(phoneNumber)
    }, [phoneNumber])

    useEffect(() => {
        if (closeDropDown) { setCustomerList([]); setCloseDropDown(false); }
    }, [closeDropDown])

    const loadCustomer = async (e) => {
        if (e.length <= 0) { setCustomerList([]); return; }
        if (e.length < 3) { return; }
        let { data, error } = await getCustomerList({
            phoneNumber: e
        })
        if (error) { console.log(error) }
        if (data) { setCustomerList(data) }
    }

    return (
        <Grid sx={{
            position: 'absolute',
            visibility: customerList.length > 0 ? 'visible' : 'none',
            background: 'white',
            zIndex: 99,
            width: 200,
            mt: 0.5,
            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;',
            cursor: 'pointer'
        }}>
            {
                customerList.map( v => {
                    return (
                        <div style={{
                            padding: 12,
                            fontSize: 12,
                            borderBottom: '0.1px #888880 solid',
                        }} onClick={(e) => {
                            if (excludeName) {
                                onChange({
                                    custPhoneNumber: v.phoneNumber
                                })
                            } else {
                                onChange({
                                    custName: v.name.toUpperCase(),
                                    custPhoneNumber: v.phoneNumber
                                })
                            }
                            onChange({addressDetail: {
                                streetName: v.address.toUpperCase()
                            }})
                            setCustomerList([])
                            setAllowFilter(false)
                            e.stopPropagation()
                        }}>{v.name}</div>
                    )
                })
            }
        </Grid>
    )
}

export default CustomerDropDown